import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export class GeneralPropertyDataOptions extends LayoutRenderLayoutItemOptions {
	hideFields?: string[];

	constructor() {
		super();
		this.hideFields = [];
	}
}
